import React from 'react';
import { Route } from 'react-router-dom';
import Fetch from '../../common/components/Fetch';
import LoadingView from '../../common/components/LoadingView';
import NotFoundPage from '../../common/components/NotFound/PageNotFound';
import StandardPageTemplate from '../../common/components/Layout/StandardPageTemplate';
import objectToArray from '../../common/utils/object-to-array';

const templates = {
  // component
  antman: {
    Component: require('./Templates/Antman').default,
    AdminPage: require('./Templates/Antman').Admin,
  },
  beast: {
    Component: require('./Templates/Beast').default,
    AdminPage: require('./Templates/Beast').Admin,
  },
  colossus: null,
  drax: null,
  electro: null,
  firestar: null,
  groot: null,
};

const TemplateEngine = ({ pages } = {}) => props => {
  const { match, location } = props;
  const { pageKey } = match.params;
  const pageArr = objectToArray(pages || {});
  const adminPage = /[?&]admin=([a-z]+)&?/.exec(location.search);
  const page = pageKey
    ? pageArr.find(p => p.key === pageKey)
    : pageArr.find(p => p.isDefault);

  if (adminPage) {
    const template = templates[adminPage[1]];
    if (template) {
      return <template.AdminPage page={page} />;
    }
  }

  if (!page || !page.isActive) {
    return <NotFoundPage />;
  }
  const template = templates[page.template];
  if (adminPage && adminPage[1] === 'marvel') {
    return <template.AdminPage page={page} />;
  }
  return template ? (
    <template.Component page={page} {...props} />
  ) : (
    <NotFoundPage />
  );
};

const Entry = ({ match: { path } }) => {
  return (
    <StandardPageTemplate defaultDocTitle="NFIB">
      <Fetch url="/api/config/pages/join" normalize={false}>
        {({ data, pending }) => {
          return pending ? (
            <LoadingView />
          ) : (
            <Route
              path={`${path}/:pageKey?/:promoCode?`}
              render={TemplateEngine(data)}
            />
          );
        }}
      </Fetch>
    </StandardPageTemplate>
  );
};

export default Entry;



// WEBPACK FOOTER //
// ./src/App/join/index.js